module.exports = __webpack_public_path__ + "static/media/united-arab-emirates.0fd33949.png";